{
  "sf_user_permission_checker": {
    "filters_title": "FILTROS",
    "search_placeholder": "Pesquisar...",
    "header": "Verificador de Permissões Tuvis",
    "cols": {
      "name": "Nome do Componente",
      "label": "Etiqueta do Componente",
      "parent": "Objeto Pai",
      "type": "Tipo",
      "viewPermission": "Permissão de Visualização",
      "writePermission": "Permissão de Escrita"
    },
    "permission": {
      "allow": "Permitir",
      "denied": "Negado",
      "unknown": "Desconhecido",
      "none": "Nenhum"
    },
    "type": {
      "class": "Classe Apex",
      "field": "Campo Personalizado",
      "object": "Objeto Personalizado",
      "visualforce_page": "Página Visualforce"
    }
  },
  "new_word": "Novo",
  "crm_settings": {
    "country_code": "Código do país",
    "users_deactivation": "Desativação de usuários",
    "auto_sync": "Sincronização automática"
  },
  "country_codes": {
    "title": "Gerenciar códigos de país",
    "manage_codes": "Gerenciar códigos de país",
    "test_tool": "Ferramenta de teste",
    "test_tool_description": "Insira um número de telefone igual como você faz no Salesforce para verificar a resposta de roteamento",
    "phone_number": "Número de telefone",
    "test_now": "teste agora",
    "invalid_phone": "o número indicado não corresponde ao padrão de telefone celular",
    "copy_to_clipboard": "Copiar para a área de transferência",
    "test_results_copied": "Resultados do teste copiados para a área de transferência",
    "manage_codes_subtitle": "Selecione o código do país que você usa com mais frequência",
    "manage_codes_desctiption": "Atualizamos estas configurações a cada 24 horas. Para atualizá-las agora, por favor, encerre a sessão e faça um novo login no painel do agente",
    "search_countries": "Buscar países",
    "save": "salvar modificações",
    "max_countries_recommendation": "Recomenda-se incluir até 5 códigos de país",
    "max_countries_warning": "Você só pode selecionar até 5 códigos de países",
    "saved_successfully": "As configurações de código de país foram salvas com sucesso",
    "saved_failed": "Falha ao salvar as configurações de código de país",
    "loading": "Carregando"
  },
  "autoSyncPage": {
    "header": "Sincronização automática",
    "modalTitle": "Apagar mensagens",
    "modalButton": "Excluir",
    "desc": "Exclua todo o histórico de mensagens sincronizadas de todos os contatos. Essa ação não pode ser desfeita",
    "button": "Excluir todas as mensagens",
    "confirmDeleteModalText": "Isso excluirá todas as mensagens do WhatsApp que foram sincronizadas com o Salesforce, incluindo todos os status que cada usuário fez e quaisquer outras configurações\nrelacionados à sincronização automática.",
    "confirmDeleteModalConfirm": "Você tem certeza disso?",
    "delete_all_placeholder": "Digite 'DELETE ALL' para prosseguir",
    "delete_success": "Todas as mensagens foram excluídas com sucesso",
    "delete_failure": "Falha na operação. Por favor, entre em contato com o suporte",
    "loading": "Carregando"
  },
  "usersDeactivationPage": {
    "never": "Nunca",
    "Every_1_hour": "Cada 1 hora",
    "Every_6_hour": "Cada 6 horas",
    "Every_6_hour_desc": "Funciona todos os dias às 00:00, 06:00, 12:00, 18:00",
    "Every_12_hour": "A cada 12 horas",
    "Every_12_hour_desc": "Funciona todos os dias às 00h, 12h",
    "Every_24_hour": "Cada 24 horas",
    "Every_24_hour_desc": "Funciona todos os dias à meia-noite",
    "Every_2_days": "A cada 2 dias",
    "Every_2_days_desc": "Funciona às segundas, quartas e sextas-feiras às 12h",
    "Every_7_days": "A cada 7 dias",
    "Every_7_days_desc": "Funciona todos os domingos às 12h",
    "header": "Desativação de usuário",
    "runNow": "Executar agora",
    "saveSettings": "Salvar configurações",
    "previousRun": "Execução anterior",
    "nextRun": "Próxima execução",
    "modal_start_now": "Execução do trabalho iniciada com sucesso",
    "modal_finish_now": "Trabalho finalizado com sucesso",
    "modal_saved_interval": "Novo intervalo de trabalho salvo com sucesso",
    "desc": "Defina um intervalo de desativação automática do usuário:",
    "loading": "Carregando"
  },
  "autoSyncActivitiesPage": {
    "never": "Nunca",
    "Every_1_hour": "Cada 1 hora",
    "Every_6_hour": "Cada 6 horas",
    "Every_6_hour_desc": "Funciona todos os dias às 00:00, 06:00, 12:00, 18:00",
    "Every_12_hour": "A cada 12 horas",
    "Every_12_hour_desc": "Funciona todos os dias às 00h, 12h",
    "Every_24_hour": "Cada 24 horas",
    "Every_24_hour_desc": "Funciona todos os dias à meia-noite",
    "Every_2_days": "A cada 2 dias",
    "Every_2_days_desc": "Funciona às segundas, quartas e sextas-feiras às 12h",
    "Every_7_days": "A cada 7 dias",
    "Every_7_days_desc": "Funciona todos os domingos às 12h",
    "runNow": "Executar agora",
    "saveSettings": "Salvar configurações",
    "previousRun": "Execução anterior",
    "nextRun": "Próxima execução",
    "modal_start_now": "Execução do trabalho iniciada com sucesso",
    "modal_finish_now": "Trabalho finalizado com sucesso",
    "modal_saved_interval": "Novo intervalo de trabalho salvo com sucesso",
    "loading": "Carregando",
    "header": "Sincronização automática de atividades",
    "desc": "Definir um intervalo de criação automatizada de atividades:"
  },
  "autoSyncCasesPage": {
    "header": "Sincronização automática de casos",
    "desc": "Defina um intervalo para criação automática de casos:"
  },
  "chat_component": {
    "message_history": "Histórico de Mensagens",
    "date_cannot_be_older_than_x_months": "A data não pode ser anterior a {{months}} meses",
    "date_range_cannot_be_longer_than_x_days": "O intervalo de datas não pode ter mais de {{days}} dias",
    "select_all": "Selecionar Tudo",
    "deselect_all": "Desmarcar tudo",
    "export_pdf": "Exportar PDF",
    "export_csv": "Exportar CSV",
    "edited": "Editada",
    "deleted": "Excluída",
    "loading": "Carregando",
    "synced_messages": "Mensagens sincronizadas",
    "by_tuvis": "por Tuvis",
    "no_message_1": "Ainda não há mensagens",
    "no_message_2": "Ative a opção de sincronização automática no Painel do Agente Tuvis para começar a sincronizar os chats",
    "selected": "selecionado",
    "delete_messages": "Excluir mensagens",
    "download_messages": "Baixar",
    "synced_by": "Sincronizado por",
    "sent_by": "Enviado por",
    "received_by": "Recebido por",
    "filters_title": "FILTRAR MENSAGENS SINCRONIZADAS",
    "search_group_placeholder": "Buscar grupo",
    "search_input_placeholder": "Buscar mensagens",
    "search_matches": "{{currentIndex}} de {{numOfMatches}} resultados",
    "today": "Hoje",
    "yesterday": "Ontem",
    "personal": "Pessoal",
    "groups": "Grupos",
    "no_link": "No groups currently linked",
    "premium_feature_header": "🔓 Desbloquear Recurso Premium",
    "premium_feature_text": "Faça upgrade para acessar nosso recurso premium e elevar sua experiência ao próximo nível.",
    "premium_feature_contact_sales": "Entre em contato com vendas",
    "voice_message": "Mensagem de voz",
    "last_months": "Últimos {{months}} meses",
    "messages_created_date": "Data de criação das mensagens",
    "by_last_months": "Pelos últimos meses",
    "by_date_range": "Por intervalo de datas",
    "date_cannot_be_in_future": "A data não pode estar no futuro",
    "from_date_cannot_be_bigger_then_to_date": "A data inicial não pode ser posterior à data final",
    "to_date_cannot_be_smaller_then_from_date": "A data final não pode ser anterior à data inicial",
    "from": "De",
    "to": "Até",
    "apply": "Aplicar",
    "contact": {
      "name_one": "{{contactName}}",
      "name_other": "{{contactName}} e outras {{numberOfContacts}} pessoas",
      "footer_one": "Mensagem",
      "footer_other": "Ver tudo",
      "modal_header_one": "Ver Contato",
      "modal_header_other": "{{count}} Contatos",
      "birthday": "Aniversário"
    },
    "you": "Você",
    "customer": "Cliente",
    "click_to_remove": "Clique para remover",
    "forwarded": "Encaminhada",
    "broadcast_list": "Lista de transmissão",
    "location": "Localização",
    "disappearing_message": "Mensagem temporária"
  },
  "chat_groups": {
    "title": "Chat de Grupos",
    "group_name": "Nome do grupo",
    "participants": "Participantes",
    "number_of_messages": "Número de mensagens",
    "last_message": "Last message",
    "search_groups": "Buscar grupos",
    "no_groups_to_show": "There are no groups to show",
    "no_results_found": "No results found",
    "try_different_keywords": "Try different keywords or make sure",
    "spelled_correctly": "everything is spelled correctly.",
    "back_to_groups_chats": "Back to Groups Chats",
    "number_of_participants": "{{numberOfMembers}} participants",
    "entity_unknown": "Unknown",
    "entity_contact": "Contact",
    "entity_lead": "Lead",
    "entity_blacklisted": "Bloqueado",
    "entity_blocked": "Bloqueado",
    "User": "User",
    "entity_sf_user": "Salesforce User",
    "entity_sf_manager": "Salesforce Manager",
    "entity_account": "Account",
    "search_matches": "{{currentIndex}} out of {{numOfMatches}} matches",
    "no_records_found": "No records found",
    "open_group_panel_to_link": "Open the group panel to link contacts",
    "search_message": "Search message",
    "selected": "Selected",
    "delete_messages": "Delete messages",
    "premium_feature_header": "Recurso Premium",
    "message_only_for_upgraded_users": "Esta opção está disponível apenas para usuários premium",
    "filters": {
      "created_by_me": "Criado por mim",
      "groups_im_in": "Grupos dos quais participo",
      "no_groups_to_show": "Não há grupos para mostrar com as condições atuais dos filtros"
    }
  },
  "entity_sf_user": "User",
  "error_try_again": "Please try again later",
  "search_person": {
    "loading": "Loading..."
  },
  "entity_filter": {
    "me": "Eu",
    "clear_all": "Limpar tudo",
    "reset_filter": "Redefinir filtro"
  },
  "admin_only": "This page is only for Tuvis Admin!",
  "admin_or_sys_admin_only": "This page is only for Tuvis Admin or System Admin!",
  "missing_template_tuvis_custom_permission": "You don't have access to this page. Please contact your Salesforce Administrator. Required custom permission: Tuvis_Allow_Access_To_Templates_Tab",
  "user_management": {
    "headers": {
      "user_details": "Detalhes do Usuário",
      "configurations": "Configurações"
    },
    "delete_pending_user_modal": {
      "line1": "Are you sure you want to remove <{{email}}>?",
      "line2": "They will not have access to Tuvis.",
      "title": "Are you sure?"
    },
    "disable_user_modal": {
      "line1": "This will immediately revoke the access for this user.",
      "line2": "Are you sure about it?",
      "title": "Disable user",
      "okText": "Disable user"
    },
    "user_layout_modal": {
      "title": "Layout do usuário"
    },
    "invite_user_modal": {
      "username": "Usuário",
      "primary_user_must_manage_users": "Usuario principal deve ter permissão para gerenciar outros usuários",
      "inherited_from_group_one": "Herdado do grupo {{groupNames}}",
      "inherited_from_group_other": "Herdado de {{groupNames}} grupos",
      "subtitle": "Detalhes do admin",
      "title": "Convidar membros para Tuvis",
      "new_org": "New organization",
      "org_name": "Organization name",
      "okText": "Convidar ({{emailsToInviteCount}})",
      "user_update_success": "Usuário atualizado com sucesso",
      "user_update_failure": "Falha ao atualizar usuário",
      "email": "Email",
      "first_name": "Nome",
      "last_name": "Sobrenome",
      "notify_inviter_on_sidecar_events": "Notificar-me sobre as conexões do Remote Sync",
      "permissions": {
        "title": "Permissões",
        "update_success": "Permissões atualizadas com sucesso",
        "update_failure": "Permissões não atualizadas",
        "show_analytics_ui": "Acesso Insights de engajamento",
        "show_dashboards_ui": "Acesso a Dashboards",
        "analytics_compliance": "Acesso a Conformidade",
        "show_chat_groups_ui": "Acesso Chat de Grupos",
        "sidecars_enabled": "Acesso Remote Sync UI",
        "allow_inviting_users": "Acesso Gerenciamento de usuários UI",
        "allow_desktop_lite": "Acesso ao Tuvis Desktop Lite",
        "allow_platform_integrations": "Acesso Integrações UI",
        "allow_platform_admin_notifications": "Acesso à UI de Notificações",
        "allow_platform_global_layout": "Acesso à UI de Layout global",
        "access_audit_log": "Acesso Registro de auditoria UI",
        "show_saml_settings": "Acesse as Configurações de SSO"
      },
      "granular_permissions": {
        "sidecars_enabled": "Tuvis Remote Sync",
        "sidecars": {
          "view": "Visualizar",
          "create": "Criar",
          "invite": "Convidar",
          "update": "Atualizar",
          "delete": "Excluir",
          "view_messages": "Visualizar mensagens",
          "all": "Tudo",
          "notifications": "Notificações"
        },
        "allow_messages_analytics": "Análise de Mensagens",
        "messages_analytics": {
          "view": "Visualizar",
          "export": "Exportar",
          "all": "Tudo"
        },
        "allow_platform_integrations": "Integrações",
        "destinations": {
          "view": "Visualizar",
          "update": "Atualizar",
          "delete": "Excluir",
          "all": "Tudo"
        },
        "show_saml_settings": "Configurações de SSO",
        "saml": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Tudo"
        },
        "access_audit_log": "Registro de auditoria",
        "audit_log": {
          "view": "Visualizar"
        },
        "allow_platform_global_layout": "Layout global",
        "global_layout": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Tudo"
        },
        "allow_platform_admin_notifications": "Notificações do sistema",
        "notifications": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Tudo"
        },
        "allow_desktop_lite": "Tuvis Desktop lite",
        "allow_mobile_call_recording": "Allow mobile call recordings",
        "allow_inviting_users": "Gerenciamento de usuários",
        "show_im_groups_ui": "Grupos de MI",
        "im_groups": {
          "view": "Visualizar"
        },
        "user_management": {
          "view": "Visualizar",
          "invite": "Convidar",
          "activate": "Ativar",
          "update_permissions": "Atualizar permissões",
          "view_groups": "Visualizar grupos",
          "update_groups": "Atualizar grupos",
          "assign_groups": "Atribuir grupos",
          "edit_user": "Editar usuário",
          "view_messages": "Ver mensagens",
          "merge": "Mesclar usuários",
          "all": "Tudo"
        },
        "show_chat_groups_ui": "Chat de Grupos",
        "chat_groups": {
          "view": "Visualizar"
        },
        "show_analytics_ui": "Painel de engajamento",
        "analytics": {
          "view": "Visualizar",
          "view_messages": "Ver mensagens"
        },
        "show_dashboards_ui": "Dashboards",
        "show_custom_filters_ui": "Filtros personalizados",
        "dashboards": {
          "view": "Visualizar",
          "update": "Atualizar",
          "create": "Criar",
          "all": "Tudo"
        },
        "custom_filters": {
          "view": "Visualizar",
          "update": "Atualizar",
          "create": "Criar",
          "all": "Tudo"
        },
        "analytics_compliance": "Conformidade",
        "compliance": {
          "view": "Visualizar"
        },
        "allow_incidents": "Incidentes",
        "incident": {
          "view": "Ver incidentes",
          "update": "Atualizar incidentes"
        },
        "allow_dlp": "Data Loss Protection",
        "enable_surveillance": "Surveillance",
        "surveillance": {
          "view": "Ver políticas",
          "update": "Atualizar políticas",
          "view_incidents": "Ver incidentes",
          "view_analytics": "Ver análises",
          "update_incidents": "Atualizar incidentes",
          "all": "Tudo"
        },
        "dlp": {
          "view": "Ver políticas",
          "update": "Atualizar políticas",
          "view_analytics": "Ver analytics",
          "all": "Tudo"
        },
        "allow_waba": "WhatsApp Business API",
        "waba": {
          "view_settings": "Ver configurações",
          "update_settings": "Atualizar configurações ",
          "agent": "Agent",
          "all": "Tudo"
        },
        "allow_twilio": "Gravação de chamadas da Tuvis",
        "twilio": {
          "view_settings": "Ver configurações",
          "update_settings": "Atualizar configurações ",
          "agent": "Agent",
          "all": "Tudo"
        },
        "allow_customer_facing_settings": "Configurações",
        "settings": {
          "view_general": "Ver configurações",
          "update_general": "Atualizar configurações",
          "view_api_keys": "Visualizar Chaves API",
          "update_api_keys": "Atualizar Chaves API",
          "all": "Tudo"
        },
        "allow_public_api": "Chaves API",
        "api_keys": {
          "view": "Ver",
          "update": "Atualizar",
          "all": "Tudo"
        },
        "allow_url_policy": "Política de URL",
        "url_policy": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Todos"
        },
        "allow_tuvis_browser": "Tuvis Browser",
        "browser_url_policy": {
          "view": "Visualizar políticas de acesso",
          "update": "Atualizar políticas de acesso",
          "all": "Todas as políticas de acesso"
        },
        "browser_controls": {
          "view": "Visualizar controles do navegador",
          "update": "Atualizar controles do navegador",
          "all": "Todos os controles do navegador"
        },
        "access_requests": {
          "view": "Visualizar solicitações de acesso",
          "update": "Gerenciar solicitações de acesso",
          "all": "Todas as solicitações de acesso"
        },
        "secure_storage": {
          "view": "Ver armazenamento seguro",
          "update": "Gerenciar armazenamento seguro",
          "all": "Todo o armazenamento seguro"
        },
        "allow_keyword_insights": "Análise de palavras-chave",
        "keyword_insights": {
          "view": "Visualizar",
          "update": "Atualizar",
          "view_analytics": "Ver análisis",
          "all": "Todos"
        },
        "allow_phones_blocklist": "Números de telefone privados",
        "phones_blocklist": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Todos"
        },
        "allow_blocked_phones": "Bloquear Telefones (chat)",
        "blocked_phones": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Todos"
        },
        "allow_phones_whitelist": "Lista de Telefones Permitidos",
        "phones_whitelist": {
          "view": "Visualizar",
          "update": "Atualizar",
          "all": "Todos"
        },
        "allow_tuvis_contacts": "Tuvis Contacts",
        "tuvis_contacts": {
          "view": "Visualizar",
          "create": "Criar",
          "update": "Atualizar",
          "all": "Todos"
        },
        "allow_slack_platform": "Plataforma de Slack",
        "slack": {
          "view_settings": "Visualizar configurações",
          "update_settings": "Atualizar configurações",
          "all": "Todos"
        },
        "allow_teams_platform": "Plataforma de Teams",
        "teams": {
          "view_settings": "Visualizar configurações",
          "update_settings": "Atualizar configurações",
          "all": "Todos"
        },
        "allow_bot_builder": "Bot Builder",
        "allow_elite_token": "Token de Segurança Elite",
        "elite_token": {
          "all": "Tudo",
          "view": "Visualizar",
          "update": "Gerar"
        },
        "bot_builder": {
          "view_analytics": "Ver analytics",
          "view": "Visualizar",
          "update": "Atualizar",
          "view_triggers": "Visualizar disparadores",
          "trigger_flows": "Disparar fluxos",
          "all": "Todos"
        },
        "fraud_detection": "Detecção de Fraude",
        "phishing_fraud_detection": "Detecção de Phishing",
        "fraud": {
          "view": "Visualizar",
          "update": "Atualizar",
          "view_incidents": "Ver incidentes",
          "view_urls": "Ver URLs",
          "update_urls": "Atualizar URLs",
          "update_incidents": "Atualizar incidentes",
          "all": "Todos"
        },
        "allow_archive": "Arquivo",
        "archive": {
          "view_settings": "Visualizar configurações",
          "update_settings": "Atualizar configurações",
          "all": "Todos"
        },
        "allow_im_templates": "Modelos de mensagens",
        "allow_secure_storage": "Armazenamento seguro",
        "secure_storage_retention_days": "Retenção do armazenamento seguro (dias)",
        "secure_storage_allow_user_delete": "Os usuários podem excluir seus arquivos do armazenamento seguro",
        "im_templates": {
          "all": "Todos",
          "view": "Visualizar",
          "create": "Criar",
          "update": "Atualizar",
          "delete": "Excluir"
        }
      }
    },
    "no_users_to_show": "There are no users to show",
    "no_pending_users_to_show": "There aren’t any pending members",
    "title": "Gerenciamento de usuários",
    "purchased_licenses": "{{numOfSeats}} Licenças Compradas",
    "consumed_licenses": "{{numOfUsedSeats}} Licenças Consumidas",
    "users_count": "{{activeSeats}} Usuários",
    "download_csv": "Download CSV",
    "invite_users": "Convidar usuário",
    "drop_csv": "Solte o arquivo CSV aqui ou clique para procurar",
    "csv_errors": {
      "empty_file": "O arquivo CSV está vazio",
      "missing_required_headers": "Faltam cabeçalhos obrigatórios no arquivo CSV: {{missingRequiredHeaders}}",
      "invalid_headers": "O arquivo CSV contém cabeçalhos inválidos: {{invalidHeaders}}",
      "invalid_emails": "O arquivo CSV contém linhas com e-mails inválidos: {{invalidEmails}}",
      "invalid_phones": "O arquivo CSV contém linhas com telefones inválidos: {{invalidPhones}}",
      "missing_first_name": "O arquivo CSV contém linhas com nome ausente: {{missingFirstName}}",
      "missing_last_name": "O arquivo CSV contém linhas com sobrenome ausente: {{missingLastName}}"
    },
    "import_users_preview": "Pré-visualização",
    "import_users_csv_button": "Importar CSV",
    "import_users_csv_template": "Baixar Modelo de CSV",
    "required": "obrigatório",
    "import_button": "Importar",
    "update_existing_users": "Atualizar usuários existentes",
    "import_users_modal_text": "Crie um arquivo CSV: Certifique-se de que seu arquivo CSV inclua as seguintes colunas:",
    "import_users_csv_invalid_format": "Formato de arquivo inválido {{header}}",
    "import_users_csv_success": "Resultados da importação: {{numOfNewUsers}} novos usuários adicionados a partir do arquivo CSV, {{numOfExistingUsers}} usuários ignorados devido a registros existentes.",
    "import_users_csv_success_update": "Resultados da importação: {{numOfNewUsers}} novos usuários adicionados, {{numOfUpdatedUsers}} usuários existentes atualizados.",
    "import_users_csv_failure": "Falha ao importar usuários {{error}}",
    "invite_users_failure": "Falha ao convidar usuários {{error}}",
    "search_users_placeholder": "Procurar usuário",
    "search_pending_users_placeholder": "Procurar usuário pendente",
    "change_sidecars_settings_failure": "Falha ao alterar as configurações do dispositivo",
    "change_sidecars_settings_success": "Configurações do dispositivo alteradas com sucesso",
    "filters": {
      "title": "FILTRAR USUÁRIOS",
      "hide_users": "Mostrar apenas ativos (Tuvis)",
      "online_only": "Apenas online",
      "restrict_to_direct_reports": "Restringir a subordinados directos",
      "permissions": "Permissões"
    },
    "tabs": {
      "users": "USUÁRIOS",
      "pending": "USUÁRIOS PENDENTES"
    },
    "cols": {
      "avatar": "Avatar",
      "name": "Nome",
      "username": "Usuário",
      "phone": "Telefone",
      "platform": "Plataforma",
      "channels": "Canais",
      "roles": "Cargo",
      "profile": "Perfil",
      "created": "Data de criação",
      "last_login": "Último login",
      "last_login_platform": "Último login (Plataforma)",
      "last_login_desktop": "Último login (Desktop)",
      "last_login_extension": "Último login (Extension)",
      "last_login_mobile": "Último login (Móvel)",
      "desktop_version": "Versão do Desktop",
      "active_sf": "Ativo (SF)",
      "active_tuvis": "Ativo (Tuvis)",
      "auto_sync_person": "Modo de Sincronização Automática Padrão (Pessoa)",
      "auto_sync_group": "Modo de Sincronização Automática Padrão (Grupo)",
      "groups": "Grupos",
      "userId": "ID usuário",
      "orgId": "ID organização",
      "login_provider": "Provedor de login",
      "login_provider_user_id": "Provedor de Login - ID do Usuário",
      "email": "E-mail",
      "manager": "Gerente",
      "online": "Online",
      "online_tooltip": "Online nos últimos 5 minutos no {{source}}",
      "offline_tooltip": "Inativo nos últimos 5 minutos no Tuvis Desktop App"
    },
    "groups": {
      "remove_group": "Remover grupo {{name}}",
      "add_group": "Adicionar grupo"
    },
    "pending_cols": {
      "email": "Email",
      "invite_date": "Invite date",
      "actions": "Actions"
    },
    "actions": {
      "delete": "Excluir",
      "confirm_delete_title": "Excluir usuário",
      "confirm_delete_text": "Excluir um usuário não pode ser desfeito. Tem certeza de que deseja excluir este usuário?",
      "delete_success": "Usuário excluído com sucesso",
      "delete_failure": "Falha ao excluir usuário",
      "update": "Atualizar",
      "resend_invite": "Reenviar convite",
      "resend_success": "Convite reenviado com sucesso",
      "resend_failure": "Falha ao reenviar convite"
    },
    "platform": {
      "extension": "Extensão",
      "desktop": "Desktop",
      "platform": "Plataforma"
    }
  },
  "manageTemplates": {
    "seems_like_no_templates": "Parece que você ainda não tem modelo de mensagens dinâmicos",
    "time_to_create_a_new_one": ", mas é o momento perfeito para criar o seu primeiro.",
    "templates_library": "Biblioteca de Modelos",
    "search_templates": "Procurar modelos",
    "no_templates_to_show": "Não há modelos para mostrar",
    "template_name": "Nome do modelo",
    "status": "Status",
    "visibility": "Visibilidade",
    "message": "Mensagem",
    "owner": "Proprietário",
    "created_date": "Data de criação",
    "last_modified": "Última modificação",
    "filters_title": "FILTRAR TEMPLATES",
    "filters_status": "Status",
    "filters_visibility": "Visibilidade",
    "filters_visibility_hidden": "Oculto",
    "filters_visibility_visible": "Visível",
    "delete_template_modal_part_1": "Tem certeza de que deseja excluir o",
    "delete_template_modal_part_2": "modelo?",
    "delete_template_modal_title": "Excluir modelo",
    "delete_template_modal_ok": "Excluir",
    "selected_templates": "Modelos",
    "delete_templates": "Excluir modelos",
    "delete_templates_modal_title": "Excluir modelos",
    "delete_templates_modal_ok": "Excluir",
    "delete_templates_modal_text": "Tem certeza de que deseja excluir {{count}} modelos?",
    "activate_templates": "Ativar modelos",
    "activate_templates_modal_title": "Ativar modelos",
    "activate_templates_modal_ok": "Ativar",
    "activate_templates_modal_text": "Tem certeza de que deseja ativar {{count}} modelos?",
    "stop_templates": "Parar modelos",
    "stop_templates_modal_title": "Parar modelos",
    "stop_templates_modal_ok": "Parar",
    "stop_templates_modal_text": "Tem certeza de que deseja parar {{count}} modelos?"
  },
  "create_or_edit_templates": {
    "template_preview_placeholder": "Mensagem de modelo",
    "template_preview": "Visualização do modelo",
    "too_many_file_upload": "Você pode enviar até 4 arquivos. Se desejar alterar os arquivos, por favor, exclua o arquivo selecionado primeiro.",
    "failed_to_save": "Falha ao salvar o modelo",
    "template_must_have_name": "O modelo deve ter um nome",
    "template_must_include_message": "O modelo deve incluir uma mensagem",
    "save": "Salvar",
    "template": "MODELO",
    "template_name": "Nome do Modelo",
    "settings": "CONFIGURAÇÕES",
    "status": "Status",
    "active": "Ativo",
    "stopped": "Parado",
    "public": "Público",
    "editable": "Editável",
    "visibility_rules": "Regras de visibilidade",
    "choose_users": "Escolha quais usuários podem ver e usar este modelo.",
    "add_new_rule": "Adicionar Nova Regra",
    "message": "Mensagem",
    "insert_personalized_token": "Insira um token personalizado",
    "visibility_rules_section": "REGRAS DE VISIBILIDADE",
    "search_rule_name": "Pesquisar nome da regra",
    "search_personalized_token": "Pesquisar token personalizado",
    "create_template": "Criar Modelo",
    "edit_template": "Editar Modelo",
    "personalized_modal": {
      "title": "Definir valor padrão para {{personalizedLabel}}",
      "done": "Concluído",
      "default_value": "Valor padrão",
      "text_trans": {
        "header": "Transformações",
        "lowercase": "minúsculas",
        "uppercase": "MAIÚSCULAS",
        "capitalize": "Capitalizar Cada Palavra",
        "none": "Nenhum"
      }
    },
    "upload_images": {
      "upload_images": "Enviar Arquivos",
      "record_audio": "Gravar mensagem de voz",
      "recording_audio": "Gravando mensagem de voz",
      "up_to_4_images": "Até 4 arquivos",
      "supported_files": "Arquivos suportados: jpg, png, gif, pdf, ogg, aac, amr",
      "recommended_max_size": "Tamanho máximo: 3 MB.",
      "recording_cannot_have_text": "Uma gravação não pode ser enviada com texto, a mensagem do modelo será ignorada",
      "file_exceeds_size_limit": "Arquivo(s) excederam o limite de {{maxSize}} MB e não foram enviados: {{fileNames}}"
    }
  },
  "common": {
    "open_salesforce": "Voltar ao Salesforce",
    "crm_table": {
      "no_results_found": "Nenhum resultado encontrado",
      "try_other_filters_combination": "Experimente outra combinação de filtros",
      "try_different_keywords": "Tente palavras-chave diferentes ou certifique-se",
      "spelled_correctly": "de que tudo está escrito corretamente."
    }
  },
  "tuvisSetup": {
    "welcome": "Bem-vindo ao Tuvis",
    "description": "Precisa de ajuda para começar ou aprender mais sobre nossos recursos?",
    "doc_link": "Consulte nossa documentação"
  },
  "adminNotifications": {
    "user_logged_out": "Usuário desconectado",
    "user_uninstall_extension": "Usuário desinstalou a extensão",
    "user_turned_auto_sync_off": "Usuário desativou a sincronização automática",
    "user_turned_auto_sync_on": "Usuário ativou a sincronização automática",
    "user_turned_group_auto_sync_on": "Usuário ativou a sincronização automática de grupo",
    "user_turned_group_auto_sync_off": "Usuário desativou a sincronização automática de grupo",
    "api_currently_disabled": "API atualmente desativada",
    "apex_rest_services_disabled": "Serviços de repouso APEX desativados",
    "new_user_created": "Novo usuário criado",
    "user_logged_in": "Usuário conectado",
    "monthly_user_versions_report": "Relatório mensal de versões dos usuários",
    "integration_error": "Erro de integração",
    "desktop_release": "Nova versão do app desktop lançada",
    "desktop_beta_release": "Nova versão beta do app desktop lançada",
    "title": "Notificações",
    "saveSettings": "Salvar configurações",
    "subHeader": "Notifique-me sobre...",
    "recipients": "Destinatários:",
    "recipients_text": "Adicione digitando o endereço de email ou procurando por nome (Use “,” para adicionar vários membros)",
    "nobody_emailed": "Ninguém receberá e-mails sobre este evento",
    "saved_successfully": "As configurações de notificações foram salvas com sucesso",
    "saved_failed": "Falha ao salvar as configurações de notificações"
  },
  "globalLayout": {
    "title": "Layout global",
    "failed_to_update_hide_edit_layout": "Falha ao atualizar \"Ocultar layout de edição\", por favor tente novamente mais tarde",
    "hide_edit_layout": "Ocultar layout de edição",
    "reset_user_layout": "Redefinir layout de todos os usuários da organização",
    "reset_user_layout_confirm": "Tem certeza de que deseja redefinir o layout de todos os usuários da organização?",
    "reset_user_layout_success": "O layout de todos os usuários da organização foi redefinido com sucesso",
    "reset_user_layout_failure": "Falha ao redefinir o layout de todos os usuários da organização",
    "copy_another_org_global_layout": "Copiar layout global de outra organização",
    "yes": "Sim",
    "back": "Voltar",
    "select_organization_to_copy_global_layout_from": "Selecione a organização da qual deseja copiar o layout global",
    "select": "Selecionar",
    "validate_copy_global_layout_from_other_org": {
      "row_1": "Tem certeza de que deseja copiar o layout global?",
      "row_2": "De:",
      "row_3": "Para:"
    }
  },
  "record_type_layout": {
    "select_record_type": "Selecionar tipo de registro",
    "record_type": "Tipo de registro",
    "edit": "Editar",
    "manage_record_types": "Gerenciar tipos de registro",
    "edit_record_type": "Editar tipo de registro",
    "select_record_types_to_display": "Selecionar tipos de registro para exibir abaixo do lead:",
    "make_default": "Tornar padrão",
    "default": "Padrão"
  },
  "entity_unknown": "Desconhecido",
  "entity_contact": "Contato",
  "entity_lead": "Lead",
  "entity_person_account": "Conta pessoal",
  "entity_person_account_label": "conta pessoal",
  "entity_new_person_account": "Novo Conta pessoal",
  "entity_sf_manager": "Salesforce Manager",
  "entity_account": "Conta",
  "entity_opps": "Oportunidade",
  "entity_person": "Pessoa",
  "entity_activity": "Atividade",
  "entity_activity_label": "atividade",
  "entity_task": "Tarefa",
  "entity_task_label": "tarefa",
  "entity_case": "Caso",
  "entity_new_lead": "Novo Lead",
  "entity_new_contact": "Novo Contato",
  "entity_new_account": "Nova Conta",
  "entity_new_activity": "Nova Atividade",
  "entity_new_task": "Nova Tarefa",
  "entity_new_case": "Novo Caso",
  "entity_new_event": "Novo Evento",
  "opp_form_fields_modal": {
    "submit": "Salvar",
    "title": "Fechar esta oportunidade",
    "cancel": "Cancelar"
  },
  "action_button_event": "Evento",
  "clear_all": "Limpar todos",
  "helpers_form_layouts": "Layouts de Formulário",
  "editLayouts": {
    "edit_global_layouts": "Editar layouts globais",
    "editing_the_global_layout_affects_all_records": "Editar o layout global afetará os demais registros",
    "select_layout_type": "Selecione o tipo de layout",
    "display_record_layout": "EXIBIR LAYOUT DO REGISTRO",
    "select_up_to_display_fields": "Selecione até {{numberOfFields}} campos de exibição",
    "save_changes": "Salvar alterações",
    "save_failed": "Falha ao salvar as alterações do layout",
    "multiple_record_preview": "Visualize vários registros",
    "search_field_name": "Nome do campo de pesquisa",
    "mandatory_field": "Campo obrigatório",
    "add_fields": "Adicionar campos",
    "always_require_a_value": "Sempre insira um valor neste campo para salvar um registro",
    "you_can_only_select_up to_fields": "Você só pode selecionar até {{numberOfFields}} campos"
  },
  "helpers_add_new_field": "Adicionar novos campos",
  "tuvis_messaging_app": {
    "template_sent": "Seu cliente foi notificado (usando {{templateName}}) e receberá sua mensagem assim que aceitar o convite para a conversa. Estamos aguardando a resposta dele(a) para continuar o diálogo."
  },
  "incidents_summary_email": {
    "title": "E-mail de resumo de incidentes",
    "saved_successfully": "As configurações de e-mail de resumo de incidentes foram salvas com sucesso",
    "saved_failed": "Falha ao salvar as configurações de e-mail de resumo de incidentes",
    "loading": "Carregando...",
    "sub_header": "Permitir o envio de resumo de incidentes para e-mails selecionados",
    "allow_incidents_summary_email": "Permitir e-mail de resumo de incidentes",
    "recipients": "Destinatários:",
    "recipients_text": "Adicione digitando o endereço de e-mail ou pesquisando por nome (Use “,” para adicionar vários membros)",
    "saveSettings": "Salvar configurações"
  }
}
